<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Rafineriler</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click="openRefineryDialog()">
        <v-icon left>add</v-icon>Rafineri Ekle
      </v-btn>
    </v-toolbar>

    <v-data-table :headers="refineryHeaders" :items="refineries" :loading="loading" hide-actions class="elevation-1">
      <template v-slot:items="props">
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.notes }}</td>
        <td class="text-xs-right">
          <v-icon small class="mr-2" color="blue" @click="openRefineryDialog(props.item)">edit</v-icon>
          <v-icon small color="red" @click="deleteRefinery(props.item)">delete</v-icon>
        </td>
      </template>
    </v-data-table>

    <v-dialog v-model="refineryDialog" max-width="480px" persistent>
      <v-card>
        <v-card-title><span class="headline">{{ editingRefinery.id ? 'Rafineri Düzenle' : 'Rafineri Ekle' }}</span></v-card-title>
        <v-card-text>
          <v-text-field v-model="editingRefinery.name" label="Rafineri Adı" required></v-text-field>
          <v-textarea v-model="editingRefinery.notes" label="Not" rows="2" auto-grow></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="refineryDialog = false">İptal</v-btn>
          <v-btn color="primary" :loading="saving" @click="saveRefinery">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      saving: false,
      refineryHeaders: [
        { text: 'Rafineri', value: 'name', sortable: false },
        { text: 'Not', value: 'notes', sortable: false },
        { text: 'İşlem', value: 'actions', sortable: false, align: 'right' },
      ],
      refineryDialog: false,
      editingRefinery: { id: null, name: '', notes: '' },
    };
  },
  computed: {
    refineries() { return this.$store.getters['refineries/refineries']; },
  },
  created() {
    this.loadRefineries();
  },
  methods: {
    async loadRefineries() {
      this.loading = true;
      try { await this.$store.dispatch('refineries/getRefineries'); } finally { this.loading = false; }
    },
    openRefineryDialog(item) {
      this.editingRefinery = item ? { id: item.id, name: item.name, notes: item.notes } : { id: null, name: '', notes: '' };
      this.refineryDialog = true;
    },
    async saveRefinery() {
      if (!this.editingRefinery.name) { this.notify('Rafineri adı zorunludur.'); return; }
      this.saving = true;
      try {
        if (this.editingRefinery.id) {
          await this.$store.dispatch('refineries/updateRefinery', { id: this.editingRefinery.id, payload: { name: this.editingRefinery.name, notes: this.editingRefinery.notes } });
        } else {
          await this.$store.dispatch('refineries/createRefinery', { name: this.editingRefinery.name, notes: this.editingRefinery.notes });
        }
        this.refineryDialog = false;
        await this.loadRefineries();
      } catch (e) { this.notify(this.errMsg(e)); } finally { this.saving = false; }
    },
    async deleteRefinery(item) {
      if (!confirm(`${item.name} silinsin mi?`)) return;
      try { await this.$store.dispatch('refineries/deleteRefinery', item.id); await this.loadRefineries(); }
      catch (e) { this.notify(this.errMsg(e)); }
    },
    errMsg(e) { return (e && e.response && e.response.data && e.response.data.message) || 'İşlem başarısız oldu.'; },
    notify(msg) { this.$store.state.dialog = true; this.$store.state.message = msg; },
  },
};
</script>
